import React from "react";
import AutoTyping from "react-auto-typing";
import operationImage from "../../../assets/operation-management.jpg";
import technicianImage from "../../../assets/technician-empowerment.jpg";
import customerImage from "../../../assets/customer-engagement.png";
import contractImage from "../../../assets/contract-management.png";

const FeaturesOnServices = () => {
  return (
    <div className="trackline-feature-section-wrapper">
      <div className="section-title">
        <h1 className="title">Key Features of Trackline</h1>
        <span className="subtitle" aria-hidden="true">
          <AutoTyping
            active // <boolean>
            textRef={"Features"}
            writeSpeed={150} // <number>
            deleteSpeed={150} // <number>
            delayToWrite={1000} // <number>
            delayToDelete={2000}
          />
        </span>
      </div>
      <div className="row">
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={operationImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Comprehensive Asset Management</h1>
            <ul className="main-list">
              <li>
                <h6>Centralized Asset Tracking</h6>
                <ul className="inner-list">
                  <li>
                    Manage all your assets from a single, user-friendly
                    platform. Track asset locations, statuses, and movements in
                    real-time, enabling quick resolutions and improving overall
                    visibility.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Dynamic Resource Allocation</h6>
                <ul className="inner-list">
                  <li>
                    Optimize the use of your assets with smart allocation
                    strategies that consider availability and requirements. This
                    ensures that your resources are deployed where they are
                    needed most, enhancing operational efficiency.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Proactive Asset Monitoring</h6>
                <ul className="inner-list">
                  <li>
                    Utilize advanced analytics to predict maintenance needs
                    based on historical data and usage patterns. Reduce downtime
                    and extend asset lifespans by addressing issues before they
                    escalate.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Workforce Empowerment</h1>
            <ul className="main-list">
              <li>
                <h6>Real-Time Task Assignment</h6>
                <ul className="inner-list">
                  <li>
                    Assign tasks and monitor progress in real-time, ensuring
                    your team remains engaged and productive. Trackline empowers
                    your workforce to focus on high-impact activities, reducing
                    idle time.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Mobile Access for Field Teams</h6>
                <ul className="inner-list">
                  <li>
                    Equip your field teams with mobile tools to access asset
                    information, update statuses, and communicate seamlessly
                    from anywhere. This enhances flexibility and responsiveness
                    in asset management.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={technicianImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={customerImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Compliance and Risk Management</h1>
            <ul className="main-list">
              <li>
                <h6>Streamlined Audit Trails</h6>
                <ul className="inner-list">
                  <li>
                    Simplify audits with automated logging and reporting
                    features that maintain comprehensive records of asset usage
                    and compliance. Ensure adherence to regulatory standards
                    effortlessly.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Quality Control Measures</h6>
                <ul className="inner-list">
                  <li>
                    Implement quality checks at every stage of asset management,
                    from acquisition to deployment, ensuring high standards and
                    minimizing operational risks.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Integration and Scalability</h1>
            <ul className="main-list">
              <li>
                <h6>Seamless Integration with Existing Systems</h6>
                <ul className="inner-list">
                  <li>
                    Integrate Trackline with your existing ERP and other
                    business systems to create a cohesive operational
                    environment. This integration streamlines data flow and
                    enhances overall asset visibility.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Scalable Solutions for Growing Organizations</h6>
                <ul className="inner-list">
                  <li>
                    Whether you're expanding your asset portfolio or increasing
                    operational capacity, Trackline is designed to grow with
                    you. Our flexible architecture adapts to your evolving
                    business needs.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={contractImage} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesOnServices;
